module.exports = __webpack_public_path__ + "img/bg-cooperation.db3a7c63.png";